import { VendorDetails, VendorLinkingSteps } from '@/domain/models/vendor/vendor-details/details'
import Brand from '@/main/assets/pngs/logo-mercado-pago.png'

export const getMercadoPagoDetails = (linkingSteps: VendorLinkingSteps): VendorDetails => ({
    brand: Brand,
    name: 'Mercado Pago',
    linkingSteps,
})
